import axios from 'axios';
import store from '@/store';
import router from '@/router';

// /* eslint-disable */
// export function setCommonInterceptor(axios) {
axios.interceptors.response.use(null, (error) => {
  const status = error.response.status;
  if (status === 401 || status === 403) {
    store.dispatch('logout');
    router.push({
      path: '/login',
    });
  } else if (status === 404) {
    router.push({
      path: '/',
    });
  }
});

axios.defaults.timeout = 30000;

// IE no cache
if (!axios.defaults.headers.get) {
  axios.defaults.headers.get = {};
}
axios.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
axios.defaults.headers.get['Cache-Control'] = 'no-cache';
axios.defaults.headers.get.Pragma = 'no-cache';

// }
//
// export function setDefaultOptions(axios) {
//   setCommonInterceptor(axios);
// }

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/axios.js